import { setToken, clearToken } from "./tokenStorage";

/**
 * Persist auth after login — user profile + JWT for cross-origin Bearer requests.
 */
export const saveAuthSession = (loginResponse) => {
  const data = loginResponse?.data ?? loginResponse;
  const user = data?.details ?? data?.user ?? null;
  const token = data?.token ?? null;

  if (token) {
    setToken(token);
  }

  return user;
};

export const clearAuthSession = () => {
  clearToken();
  localStorage.removeItem("user");
};
